import React from "react";
import { FormatWithCommas, resolveMismatchColumn, resolveAgingTierColumn, getStreamSide } from "@helpers/helpers";

/**
 * ExceptionsRecordColumns Component
 * Encapsulates column definitions for the exceptions record table
 */
export const ExceptionsRecordColumns = ({ translate }) => {
  return [
    {
      accessorKey: "ReconciliationStreamName",
      header: translate("exceptions-record.columns.ReconciliationStreamName"),
      canFilter: true,
      isMultiple: true,
      sortable: true,
      size: 180,
      alignment: "left",
      processFilterValue: (value, row) => {
        return row.ReconciliationStreamTag;
      },
      processFilterKey: (value, row) => {
        return "ReconciliationStreamTag";
      },
      filterType: "checkbox",
      operator: "EQ",
    },
    {
      accessorKey: "AreaName",
      header: translate("exceptions-record.columns.AreaName"),
      processFilterValue: (value, row) => {
        return row.AreaId.toString();
      },
      processFilterKey: (value, row) => {
        return "AreaId";
      },
      size: 130,
      canFilter: true,
      isMultiple: true,
      sortable: true,
      alignment: "left",
      filterType: "checkbox",
      operator: "EQ",
    },
    {
      accessorKey: "OutletName",
      header: translate("exceptions-record.columns.OutletName"),
      processFilterValue: (value, row) => {
        return row.OutletId.toString();
      },
      processFilterKey: (value, row) => {
        return "OutletId";
      },
      size: 150,
      canFilter: true,
      isMultiple: false,
      sortable: true,
      alignment: "left",
      filterType: "string",
      operator: "EQ",
    },
    {
      accessorKey: "TransactionTerminalCode",
      header: translate("exceptions-record.columns.TransactionTerminalCode"),
      processFilterValue: (value, row) => {
        return row.TransactionTerminalCode;
      },
      processFilterKey: (value, row) => {
        return "TransactionTerminalCode";
      },
      size: 150,
      canFilter: true,
      sortable: true,
      filterType: "string",
      operator: "EQ",
    },
    {
      accessorKey: "RecordMatchingKey",
      header: translate("exceptions-record.columns.RecordMatchingKey"),
      size: 150,
      sortable: true,
      canPin: false,
      canFilter: false,
      filterType: "string",
      operator: "EQ",
    },
    {
      accessorKey: "BusinessDay",
      header: translate("exceptions-record.columns.BusinessDay"),
      size: 120,
      sortable: true,
      canPin: false,
    },
    {
      accessorKey: "CreationDate",
      header: translate("exceptions-record.columns.CreationDate"),
      size: 150,
      sortable: true,
      canPin: false,
      canFilter: true,
      filterType: "date",
      splitCellValue: "T",
    },
    {
      accessorKey: "SourceAmount",
      header: translate("exceptions-record.columns.SourceAmount"),
      size: 160,
      sortable: true,
      canPin: false,
      showThousandSeperator: true,
      cell: ({ row }) => {
        return (
          row.original.SourceAmount && (
            <span className="flex flex-col items-center justify-center group font-normal">
              <span>{`${row.original.Currency} ${FormatWithCommas(
                row.original.SourceAmount
              )}`}</span>
            </span>
          )
        );
      },
    },
    {
      accessorKey: "DestinationAmount",
      header: translate("exceptions-record.columns.DestinationAmount"),
      size: 160,
      sortable: true,
      canPin: false,
      canFilter: false,
      showThousandSeperator: true,
      cell: ({ row }) => {
        return (
          row.original.DestinationAmount && (
            <span className="flex flex-col items-center justify-center group font-normal">
              <span>{`${row.original.Currency} ${FormatWithCommas(
                row.original.DestinationAmount
              )}`}</span>
            </span>
          )
        );
      },
    },
    {
      accessorKey: "Mismatches",
      header: translate("exceptions-record.columns.Mismatches"),
      size: 190,
      sortable: true,
      canPin: false,
      canFilter: false,
      alignment: "left",
      cell: ({ row }) => {
        return resolveMismatchColumn(row.original.Mismatches);
      },
    },
    {
      accessorKey: "AgingTypeTag",
      header: translate("exceptions-record.columns.AgingTier"),
      size: 130,
      cell: ({ row }) => {
        return resolveAgingTierColumn(
          row.original.AgingTier,
          row.original.AgingTier.AgingTypeTag
        );
      },
    },
    {
      accessorKey: "NumberOfAttempts",
      header: translate("exceptions-record.columns.NumberOfAttempts"),
      size: 130,
      cellAction: (value, context) => {
        window.location.href = `/exception-attempt-details?id=${context.row.original.MatchingRecordId}`;
      },
      showThousandSeperator: true,
    },
    {
      accessorKey: "ReconciliationStreamSides",
      header: translate("exceptions-record.columns.MatchingRecordId"),
      sortable: true,
      size: 200,
      alignment: "left",
      cell: ({ row }) => {
        return getStreamSide(row.original.ReconciliationStreamSides);
      },
    },
  ];
};
